import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SugargooReviewPage from "@/pages/articles/review/page";
import SugargooShippingCostPage from "@/pages/articles/shipping-cost/page";
import SugargooCouponPage from "@/pages/articles/coupon/page";
import SugargooWarehousePage from "@/pages/articles/warehouse/page";
import IsSugargooLegitPage from "@/pages/articles/legit/page";
import SugargooFindsPage from "@/pages/articles/finds/page";
import SugargooBeginnerGuidePage from "@/pages/articles/beginner-guide/page";
import SugargooDiscountCodePage from "@/pages/articles/discount-code/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReviewPage />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <SugargooShippingCostPage />,
  },
  {
    path: "/sugargoo-coupon",
    element: <SugargooCouponPage />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <SugargooWarehousePage />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsSugargooLegitPage />,
  },
  {
    path: "/sugargoo-finds",
    element: <SugargooFindsPage />,
  },
  {
    path: "/sugargoo-beginner-guide",
    element: <SugargooBeginnerGuidePage />,
  },
  {
    path: "/sugargoo-discount-code",
    element: <SugargooDiscountCodePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;